module.exports = __webpack_public_path__ + "img/logo-dark.204f1db9.png";